import React, { FunctionComponent } from 'react'
import { Path, Rect, Svg } from 'react-native-svg'

import { Tooltip } from '../../atoms/tooltip/Tooltip'
import { colors } from '../../styles/colors'
import { tID } from '../../utils/utils'

export const BlendedCareTherapyIcon: FunctionComponent<BlendedCareTherapyIconProps> = ({
  showTooltip = true,
  tooltip = 'Blended Care Therapy',
  width = 44,
  height = 44,
}) => {
  const icon = (
    <Svg width={width} height={height} viewBox={'0 0 44 44'} testID={tID('BlendedCareTherapyIcon')}>
      <Rect width={44} height={44} rx={4} fill={colors.navy1} />
      <Path fill={colors.navy5} d='m31.0226 10.6v4.672h-6.048v17.728h-5.056v-17.728h-6.016v-4.672z' />
    </Svg>
  )

  return showTooltip ? (
    <Tooltip content={tooltip} placement='bottom' hoverEnabled={true}>
      {icon}
    </Tooltip>
  ) : (
    <>{icon}</>
  )
}

export type BlendedCareTherapyIconProps = {
  showTooltip?: boolean
  tooltip?: string
  width?: number
  height?: number
}
